import { useEffect, useState } from "react";
import { MessageCircle } from "lucide-react";
import { usePrefs } from "@/context/PrefsContext";
import { useAuth } from "@/context/AuthContext";
import { api } from "@/lib/api";

export default function CareCenter() {
  const { t, lang } = usePrefs();
  const { user } = useAuth();
  const [cfg, setCfg] = useState(null);
  const [cat, setCat] = useState(null);
  const [msg, setMsg] = useState("");

  useEffect(() => { api.get("/care/categories").then((r) => setCfg(r.data)); }, []);
  const fill = (c) => {
    setCat(c.id);
    setMsg(c.template.replace("{name}", user?.name || "").replace("{institution}", user?.institution_name || "-"));
  };
  if (!cfg) return <p className="text-sm text-muted-foreground">{t("loading")}</p>;
  const waUrl = `https://wa.me/${cfg.whatsapp}?text=${encodeURIComponent(msg)}`;

  return (
    <div className="mx-auto max-w-2xl fade-up" data-testid="care-center-page">
      <p className="font-jpserif text-sm tracking-[0.3em] text-muted-foreground">サポート</p>
      <h1 className="mt-3 font-jpserif text-3xl sm:text-4xl">{t("careTitle")}</h1>
      <p className="mt-4 text-base leading-relaxed text-muted-foreground">{t("careDesc")}</p>

      <p className="mt-8 text-xs uppercase tracking-wide text-muted-foreground">{t("category")}</p>
      <div className="mt-3 grid gap-2 sm:grid-cols-2" data-testid="care-categories">
        {cfg.categories.map((c) => <button key={c.id} data-testid={`care-category-${c.id}`} data-selected={cat === c.id} onClick={() => fill(c)} className="option-card py-3 text-sm">{lang === "jp" ? c.label_jp : c.label_id}</button>)}
      </div>

      {cat && (
        <div className="mt-8 fade-up">
          <label htmlFor="care-msg" className="text-xs uppercase tracking-wide text-muted-foreground">{t("message")}</label>
          <textarea id="care-msg" data-testid="care-message-input" rows={5} value={msg} onChange={(e) => setMsg(e.target.value)} className="mt-2 w-full rounded-xl border border-input bg-card px-4 py-3 text-sm leading-relaxed outline-none focus:border-primary focus:ring-2 focus:ring-primary/20" />
          <a data-testid="care-whatsapp-button" href={waUrl} target="_blank" rel="noopener noreferrer" className="mt-4 inline-flex items-center gap-2 rounded-full bg-[#25D366] px-6 py-3 text-sm font-semibold text-white transition-transform hover:-translate-y-0.5"><MessageCircle className="h-4 w-4" />{t("openWa")}</a>
          <p className="mt-3 text-xs text-muted-foreground" data-testid="care-whatsapp-number">+{cfg.whatsapp}</p>
        </div>
      )}
    </div>
  );
}
